import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { About } from './pages/About';
import { Research } from './pages/Research';
import { Certification } from './pages/Certification';
import { ProductReviews } from './pages/ProductReviews';
import { Media } from './pages/Media';
import { SupportUs } from './pages/SupportUs';
import { Contact } from './pages/Contact';
import { Product } from './pages/Product';
import { Article } from './pages/Article';
import { Video } from './pages/Video';
import { Profile } from './pages/Profile';
import { ScrollToTop } from './components/ScrollToTop';
import { DonorRecognition } from './pages/DonorRecognition';
export function AppRouter() {
  return <BrowserRouter data-id="element-12" data-mp="dw8l45d9683h">
      <ScrollToTop data-id="element-13" data-mp="dxt4cyu4a4m1" />
      <Routes data-id="element-14" data-mp="24863tob6v2by">
        <Route path="/" element={<App data-id="element-16" data-mp="2497i01ni44xw" />} data-id="element-15" data-mp="247mmo9td4hyz" />
        <Route path="/about" element={<About data-id="element-18" data-mp="246bl8gne3mb1" />} data-id="element-17" data-mp="248nxcd6gv2g6" />
        <Route path="/research" element={<Research data-id="element-20" data-mp="288gal36t1wrv" />} data-id="element-19" data-mp="289hp5hn151ec" />
        <Route path="/certification" element={<Certification data-id="element-22" data-mp="2903q1k9byy2y" />} data-id="element-21" data-mp="288yd2hk29788" />
        <Route path="/product-reviews" element={<ProductReviews data-id="element-24" data-mp="28yaebqjv1no3" />} data-id="element-23" data-mp="28zbta63zyub3" />
        <Route path="/product/:productId" element={<Product data-id="element-26" data-mp="240im0vfazzjd" />} data-id="element-25" data-mp="241jz15fvqw3q" />
        <Route path="/media" element={<Media data-id="element-28" data-mp="2ipx0ghxql75m" />} data-id="element-27" data-mp="23z7mj7sw5dy2" />
        <Route path="/article/:articleId" element={<Article data-id="element-30" data-mp="2ipesio1pp4hv" />} data-id="element-29" data-mp="2iqg7v4prgd5e" />
        <Route path="/video/:videoId" element={<Video data-id="element-32" data-mp="2ds4wgpjthul2" />} data-id="element-31" data-mp="2dr3l0jyw362t" />
        <Route path="/profile" element={<Profile data-id="element-34" data-mp="2dtg1esp018dr" />} data-id="element-33" data-mp="2drlqm77fywne" />
        <Route path="/support-us" element={<SupportUs data-id="element-36" data-mp="1q2akea7boa1v" />} data-id="element-35" data-mp="1q19c2dhoy1nu" />
        <Route path="/donor-recognition" element={<DonorRecognition data-id="element-38" data-mp="1l2xzhv00hd1x" />} data-id="element-37" data-mp="1q1rbfizngvzz" />
        <Route path="/contact" element={<Contact data-id="element-40" data-mp="1l4iwdr9st82y" />} data-id="element-39" data-mp="1l3pub3lsb6r5" />
      </Routes>
    </BrowserRouter>;
}